import moment from "moment";
import ToggleBtn from "../../../ui/new_components/common/toggle_btn";
import { UTCToLocalDate } from "../../../utils/date_util";

export enum FieldType {
  string,
  long_string,
  number,
  currency,
  file,
  boolean,
  date,
  datetime,
}
export enum InputType {
  email,
  phone,
  password,
  text,
  longText,
  number,
  checkbox,
  radio,
  switch,
  dropDown,
  date,
  dateTime,
  file,
}

export interface FormFieldProps {
  key?: any;
  form?: string;
  id?: string;
  name: string;
  placeholder?: string;
  label: string;
  type: FieldType;
  inputType: InputType;
  options?: {
    title: string;
    value: any;
  }[];
  required?: boolean;
  title?: string;
  onChange?: (t: { [key: string]: any }) => void;
  value: any;
}